import React, { useEffect, useState, useMemo } from "react";
import "../assets/MemoryWall.css";
import tree from "../assets/imgs/cristmas-tree.webp";
import Cvideo from '../assets/cristmas-video/cristmas-hero.mp4';

/* ================= DEFAULT FALLBACK MEMORIES ================= */
const initialMemories = [
    { text: "Cold December mornings at my ajoba’s house, wrapped in blankets and silence.", name: "Sneha", city: "Pune" },
    { text: "Church bells, winter air and breakfast with the whole family.", name: "Rahul", city: "Mumbai" },
    { text: "No phones, no rush — just cousins, laughter and sunlight.", name: "Ananya", city: "Bengaluru" },
    { text: "That one Christmas when everyone was home together.", name: "Vikram", city: "Nashik" },
    { text: "Hot cocoa, fairy lights and stories before sleep.", name: "Meera", city: "Delhi" }
];

const MemoryWall = () => {


    const [showSuccess, setShowSuccess] = useState(false);
    const [lastSharedMemory, setLastSharedMemory] = useState(null);



    const fonts = [
        "'Caveat', cursive",
        "'Patrick Hand', cursive",
        "'Gloria Hallelujah', cursive",
        "'Indie Flower', cursive",
        "'Shadows Into Light', cursive"
    ];



    // const [memories, setMemories] = useState(initialMemories);
    const [memories, setMemories] = useState([]);
    const [active, setActive] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [form, setForm] = useState({
        text: "",
        name: "",
        city: "",
        consent: false
    });

    /* ================= SNOW (STATIC RANDOMNESS) ================= */
    const snowflakes = useMemo(
        () =>
            Array.from({ length: 40 }).map(() => ({
                left: `${Math.random() * 100}%`,
                duration: `${6 + Math.random() * 6}s`,
                delay: `${Math.random() * 6}s`
            })),
        []
    );

    /* ================= AUTO ROTATION ================= */
    useEffect(() => {

        if (memories.length === 0) return;

        const timer = setInterval(() => {
            setActive((prev) => (prev + 1) % memories.length);
        }, 4200);
        return () => clearInterval(timer);
    }, [memories.length]);

    /* ================= LOAD FROM BACKEND ================= */
    useEffect(() => {
        fetch("https://www.samriddhidevelopers.in/backend/get-memories.php")
            .then((res) => res.json())
            .then((data) => {
                if (Array.isArray(data)) {
                    setMemories(data.length ? data : initialMemories);
                    setActive(0);
                }
            })
            .catch((err) => {
                console.error("Failed to load memories", err);
                setMemories(initialMemories);
            });
    }, []);


    /* ================= CLEAN isNew FLAG ================= */
    useEffect(() => {
        if (!memories.some((m) => m.isNew)) return;

        const t = setTimeout(() => {
            setMemories((prev) =>
                prev.map((m) => ({ ...m, isNew: false }))
            );
        }, 800);

        return () => clearTimeout(t);
    }, [memories]);

    /* ================= CARD TRANSFORM ================= */
    const getCardStyle = (index) => {
        const offset = index - active;
        const translateX = offset * 320;
        const rotate = offset === 0 ? 0 : offset < 0 ? -6 : 6;
        const scale = offset === 0 ? 1.1 : 0.92;

        return {
            transform: `translateX(${translateX}px) rotate(${rotate}deg) scale(${scale})`,
            zIndex: 10 - Math.abs(offset),
            animation: memories[index]?.isNew ? "fadeInUp 700ms ease" : "none"
        };
    };

    /* ================= SUBMIT MEMORY ================= */
    const submitMemory = async () => {
        if (!form.text.trim() || !form.consent) return;

        const newMemory = {
            text: form.text.trim(),
            name: form.name || "Anonymous",
            city: form.city || "",
            isNew: true,
            font: fonts[Math.floor(Math.random() * fonts.length)]
        };

        // Optimistic UI
        setMemories((prev) => [newMemory, ...prev]);
        setActive(0);

        // 👇 NEW
        setLastSharedMemory(newMemory);
        setShowSuccess(true);

        setIsModalOpen(false);
        setForm({ text: "", name: "", city: "", consent: false });

        try {
            await fetch("https://www.samriddhidevelopers.in/backend/add-memory.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    text: newMemory.text,
                    name: newMemory.name,
                    city: newMemory.city
                })
            });
        } catch (error) {
            console.error("Failed to save memory", error);
        }
    };


    const shareOnWhatsApp = () => {
        if (!lastSharedMemory) return;


        const message = `This Christmas, Samriddhi Group Pune is collecting memories, not entries

Here’s mine:
❝ ${lastSharedMemory.text} ❞

Add your memory to the Christmas Memory Wall:
https://www.samriddhidevelopers.in/#/memory-wall

 One special memory will be gifted a
“Christmas in Nature” weekend experience.

Because some moments deserve a place to live.`;



        const url = `https://wa.me/?text=${encodeURIComponent(message)}`;
        window.open(url, "_blank");
    };




    return (
        <>
            {/* ================= VIDEO INTRO (OPTIONAL) ================= */}
            <section className="wall-video">
                <video className="wall-video-bg" autoPlay muted loop playsInline>
                    <source src={Cvideo} type="video/mp4" />
                </video>
                <div className="wall-video-overlay">
                    <h1>Moments that feel like Christmas</h1>
                    <p>Slow down. Remember. Smile...</p>
                </div>
            </section>

            {/* ================= MEMORY WALL ================= */}
            <section className="wall-wrapper">
                <div className="wall-snow">
                    {snowflakes.map((s, i) => (
                        <span
                            key={i}
                            style={{
                                left: s.left,
                                animationDuration: s.duration,
                                animationDelay: s.delay
                            }}
                        />
                    ))}
                </div>

                <div className="wall-hero">
                    <img src={tree} loading="lazy" className="crist-tree" alt="Christmas tree" />
                    <h1 className="wall-title">
                        The Christmas <span>Memory</span> Wall
                    </h1>
                    <p className="wall-subtitle">
                        Share a memory that still makes you smile.
                    </p>
                </div>

                <div className="wall-stage">
                    <svg className="wall-path" viewBox="0 0 1000 120" preserveAspectRatio="none">
                        <path d="M 20 80 C 250 20, 750 20, 980 80" />
                    </svg>

                    <div className="wall-cards">
                        {memories.map((m, i) => (
                            <div
                                key={m.id}   // ✅ STABLE KEY
                                className={`wall-card ${i === active ? "wall-active" : ""}`}
                                style={getCardStyle(i)}
                            >
                                <span className="wall-pin" />
                                <p className="wall-memory" style={{ fontFamily: m.font }}>❝ {m.text} ❞</p>
                                <span className="wall-author">
                                    — {m.name}
                                    {m.city && `, ${m.city}`}
                                </span>
                            </div>
                        ))}
                    </div>


                    <button className="wall-nav wall-prev" onClick={() => setActive((a) => (a - 1 + memories.length) % memories.length)}>‹</button>
                    <button className="wall-nav wall-next" onClick={() => setActive((a) => (a + 1) % memories.length)}>›</button>

                    <button className="wall-add-btn" onClick={() => setIsModalOpen(true)}>
                        ➕ Add Your Memory
                    </button>
                </div>

                {/* ================= MODAL ================= */}
                {isModalOpen && (
                    <div className="wall-modal is-open">
                        <div className="wall-modal-backdrop" onClick={() => setIsModalOpen(false)} />

                        <div className="wall-modal-card">
                            <button className="wall-modal-close" onClick={() => setIsModalOpen(false)}>
                                ✕
                            </button>

                            <h3>Add a Memory</h3>

                            <input
                                type="text"
                                placeholder="First name (optional)"
                                value={form.name}
                                onChange={(e) => setForm({ ...form, name: e.target.value })}
                            />

                            <input
                                type="text"
                                placeholder="City (optional)"
                                value={form.city}
                                onChange={(e) => setForm({ ...form, city: e.target.value })}
                            />

                            <textarea
                                placeholder="Write your memory… (max 250 characters)"
                                maxLength={250}
                                value={form.text}
                                onChange={(e) => setForm({ ...form, text: e.target.value })}
                            />

                            <label className="wall-consent">
                                <input
                                    type="checkbox"
                                    checked={form.consent}
                                    onChange={(e) => setForm({ ...form, consent: e.target.checked })}
                                />
                                I’m okay with Samriddhi sharing this memory
                            </label>

                            <button className="wall-submit-btn" onClick={submitMemory}>
                                Add to the Wall 🌿
                            </button>
                        </div>
                    </div>
                )}

                {showSuccess && (
                    <div className="wall-success">
                        <div className="wall-success-card">
                            <h3>✨ Your memory is now part of our Christmas Wall</h3>
                            <p>Thank you for sharing something beautiful ❤️</p>

                            <button
                                className="wall-share-btn"
                                onClick={shareOnWhatsApp}
                            >
                                📲 Share this memory on WhatsApp
                            </button>

                            <button
                                className="wall-success-close"
                                onClick={() => setShowSuccess(false)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                )}



            </section>
        </>
    );
};

export default MemoryWall;
